// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2irZr","colBig":"styles_colBig__3lN1N","colSmall":"styles_colSmall__YgnCm"};